(function (window, document) {
  'use strict';

  var ACCESS_GUARD_ENABLED = true;
  var RULE_C_ENABLED = true;
  var BLOCKED_COUNTRIES = ['CN', 'HK', 'PK', 'IN', 'VN'];
  var BEIJING_TIMEZONES = ['Asia/Shanghai', 'Asia/Chongqing', 'Asia/Harbin', 'PRC'];
  var COUNTRY_CACHE_KEY = 'comely_access_country';
  var LOCAL_ALLOW_KEY = 'comely_access_local_allow';
  var LOCAL_ALLOW_VERSION = 2;
  var LOCAL_ALLOW_DURATION_MS = 30 * 24 * 60 * 60 * 1000;
  var LOCAL_PASSWORD_HASH = 'a35942b2b645f01a34d6b444f37c7c1005a369e5c6d4000e29f7c7698f370b97';
  var LOCAL_PASSWORD_SALT = 'comely-access-v2:';
  var LOCAL_PASSWORD_ATTEMPT_KEY = 'comely_access_password_attempts';
  var LOCAL_PASSWORD_ATTEMPT_LIMIT = 5;
  var LOCAL_PASSWORD_LOCK_MS = 30 * 1000;
  var LOCAL_PASSWORD_TRIGGER_TAPS = 5;
  var LOCAL_PASSWORD_TRIGGER_WINDOW_MS = 3 * 1000;
  var MOBILE_LOCAL_PASSWORD_TRIGGER_TAPS = 3;
  var MOBILE_LOCAL_PASSWORD_TRIGGER_WINDOW_MS = 4 * 1000;
  var MOBILE_LOCAL_PASSWORD_TRIGGER_MAX_WIDTH = 767;
  var GEO_TIMEOUT_MS = 1500;

  var BLOCKED_BROWSER_RULES = [
    { id: 'huawei-browser', pattern: /(?:^|[^a-z0-9])HuaweiBrowser\/\d/i },
    { id: 'xiaomi-browser', pattern: /(?:^|[^a-z0-9])MiuiBrowser\/\d/i },
    { id: 'uc-browser', pattern: /(?:^|[^a-z0-9])(?:UCBrowser|UCWEB)\/\d/i },
    { id: 'quark-browser', pattern: /(?:^|[^a-z0-9])Quark(?:PC)?\/\d/i },
    { id: 'sogou-browser', pattern: /(?:^|[^a-z0-9])(?:SogouMobileBrowser\/\d|MetaSr(?:\/\d)?)/i },
    { id: '360-secure-browser', pattern: /(?:^|[^a-z0-9])360SE(?:\/\d|\b)/i },
    { id: '360-extreme-browser', pattern: /(?:^|[^a-z0-9])360EE(?:\/\d|\b)/i },
    { id: 'qq-browser', pattern: /(?:^|[^a-z0-9])(?:MQQBrowser|QQBrowser)\/\d/i },
  ];

  var NON_CHROME_SAFARI_BROWSER_PATTERN = /(?:Edg(?:A|iOS)?\/|OPR\/|OPiOS\/|Firefox\/|FxiOS\/|SamsungBrowser\/|HuaweiBrowser\/|MiuiBrowser\/|UCBrowser\/|UCWEB\/|Quark(?:PC)?\/|SogouMobileBrowser\/|MetaSr(?:\/|\b)|360SE(?:\/|\b)|360EE(?:\/|\b)|MQQBrowser\/|QQBrowser\/|MicroMessenger\/|DuckDuckGo\/|YaBrowser\/)/i;

  function normalizeCountryCode(countryCode) {
    return typeof countryCode === 'string' ? countryCode.trim().toUpperCase() : '';
  }

  function normalizeLanguages(languages) {
    if (!Array.isArray(languages)) return [];
    return languages.filter(function (language) {
      return typeof language === 'string' && language.trim();
    });
  }

  function matchesBlockedCountry(countryCode) {
    return BLOCKED_COUNTRIES.indexOf(normalizeCountryCode(countryCode)) !== -1;
  }

  function matchesLanguageAndTimezone(languages, timezone) {
    var normalizedLanguages = normalizeLanguages(languages);
    var firstLanguage = normalizedLanguages.length ? normalizedLanguages[0].toLowerCase() : '';
    return /^zh(?:-|$)/.test(firstLanguage) && BEIJING_TIMEZONES.indexOf(timezone) !== -1;
  }

  function identifyBlockedBrowser(userAgent) {
    if (!RULE_C_ENABLED || typeof userAgent !== 'string' || !userAgent) return null;

    if (/MicroMessenger\//i.test(userAgent) || /(?:^|[\s;])QQ\/\d/i.test(userAgent) || /V1_(?:AND|IPH)_SQ_/i.test(userAgent)) {
      return null;
    }

    for (var index = 0; index < BLOCKED_BROWSER_RULES.length; index += 1) {
      if (BLOCKED_BROWSER_RULES[index].pattern.test(userAgent)) {
        return BLOCKED_BROWSER_RULES[index].id;
      }
    }

    return null;
  }

  function evaluateAccess(input) {
    var browser = identifyBlockedBrowser(input.userAgent);
    var reasons = [];

    if (matchesBlockedCountry(input.countryCode)) reasons.push('A');
    if (matchesLanguageAndTimezone(input.languages, input.timezone)) reasons.push('B');
    if (browser) reasons.push('C');

    return {
      blocked: reasons.length > 0,
      reasons: reasons,
      browser: browser,
    };
  }

  function getTimezone() {
    try {
      return window.Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    } catch (error) {
      return '';
    }
  }

  function getLanguages() {
    if (Array.isArray(window.navigator.languages) && window.navigator.languages.length) {
      return window.navigator.languages;
    }
    return window.navigator.language ? [window.navigator.language] : [];
  }

  function readCountryCache() {
    try {
      return window.sessionStorage.getItem(COUNTRY_CACHE_KEY) || '';
    } catch (error) {
      return '';
    }
  }

  function writeCountryCache(countryCode) {
    try {
      window.sessionStorage.setItem(COUNTRY_CACHE_KEY, normalizeCountryCode(countryCode));
    } catch (error) {
      // Storage can be unavailable in private or restricted browsing contexts.
    }
  }

  function isLocalAllowlistBrowser(userAgent) {
    if (typeof userAgent !== 'string' || !userAgent || NON_CHROME_SAFARI_BROWSER_PATTERN.test(userAgent)) {
      return false;
    }

    if (/(?:Chrome|CriOS)\/\d/i.test(userAgent)) {
      return !/(?:^|[\s;(])wv(?:[\s;)\/]|$)/i.test(userAgent);
    }

    return /Version\/\d/i.test(userAgent) && /Safari\/\d/i.test(userAgent);
  }

  function removeLocalAllowlist() {
    try {
      window.localStorage.removeItem(LOCAL_ALLOW_KEY);
    } catch (error) {
      // Storage can be unavailable in private or restricted browsing contexts.
    }
  }

  function isLocalAllowlisted(now) {
    if (!isLocalAllowlistBrowser(window.navigator && window.navigator.userAgent)) return false;

    try {
      var rawRecord = window.localStorage.getItem(LOCAL_ALLOW_KEY);
      if (!rawRecord) return false;

      var record = JSON.parse(rawRecord);
      var currentTime = typeof now === 'number' ? now : Date.now();
      if (record && record.version === LOCAL_ALLOW_VERSION && typeof record.expiresAt === 'number' && record.expiresAt > currentTime) {
        return true;
      }

      removeLocalAllowlist();
      return false;
    } catch (error) {
      removeLocalAllowlist();
      return false;
    }
  }

  function grantLocalAllowlist(now) {
    if (!isLocalAllowlistBrowser(window.navigator && window.navigator.userAgent)) return false;

    var currentTime = typeof now === 'number' ? now : Date.now();
    try {
      window.localStorage.setItem(LOCAL_ALLOW_KEY, JSON.stringify({
        version: LOCAL_ALLOW_VERSION,
        expiresAt: currentTime + LOCAL_ALLOW_DURATION_MS,
      }));
      return true;
    } catch (error) {
      return false;
    }
  }

  function bytesToHex(buffer) {
    return Array.prototype.map.call(new Uint8Array(buffer), function (byte) {
      return byte.toString(16).padStart(2, '0');
    }).join('');
  }

  function verifyLocalAllowlistPassword(password, expectedHash) {
    var passwordHash = typeof expectedHash === 'string' ? expectedHash : LOCAL_PASSWORD_HASH;
    if (!/^[a-f0-9]{64}$/i.test(passwordHash) || !window.crypto || !window.crypto.subtle || typeof window.TextEncoder !== 'function') {
      return Promise.resolve(false);
    }

    var input = new window.TextEncoder().encode(LOCAL_PASSWORD_SALT + String(password || ''));
    return window.crypto.subtle.digest('SHA-256', input).then(function (digest) {
      return bytesToHex(digest) === passwordHash.toLowerCase();
    }).catch(function () {
      return false;
    });
  }

  function readLocalPasswordAttemptState() {
    try {
      var rawState = window.localStorage.getItem(LOCAL_PASSWORD_ATTEMPT_KEY);
      if (!rawState) return { failures: 0, lockedUntil: 0 };
      var state = JSON.parse(rawState);
      return {
        failures: typeof state.failures === 'number' ? state.failures : 0,
        lockedUntil: typeof state.lockedUntil === 'number' ? state.lockedUntil : 0,
      };
    } catch (error) {
      return { failures: 0, lockedUntil: 0 };
    }
  }

  function clearLocalPasswordAttempts() {
    try {
      window.localStorage.removeItem(LOCAL_PASSWORD_ATTEMPT_KEY);
    } catch (error) {
      // Storage can be unavailable in private or restricted browsing contexts.
    }
  }

  function getLocalPasswordLockRemaining(now) {
    var currentTime = typeof now === 'number' ? now : Date.now();
    var state = readLocalPasswordAttemptState();
    var remainingMs = state.lockedUntil - currentTime;
    if (remainingMs > 0) return remainingMs;
    if (state.lockedUntil > 0) clearLocalPasswordAttempts();
    return 0;
  }

  function registerLocalPasswordFailure(now) {
    var currentTime = typeof now === 'number' ? now : Date.now();
    var existingRemaining = getLocalPasswordLockRemaining(currentTime);
    if (existingRemaining > 0) {
      return { locked: true, remainingMs: existingRemaining };
    }

    var state = readLocalPasswordAttemptState();
    state.failures += 1;
    if (state.failures >= LOCAL_PASSWORD_ATTEMPT_LIMIT) {
      state.lockedUntil = currentTime + LOCAL_PASSWORD_LOCK_MS;
    }

    try {
      window.localStorage.setItem(LOCAL_PASSWORD_ATTEMPT_KEY, JSON.stringify(state));
    } catch (error) {
      // A local delay cannot be enforced when storage is unavailable.
    }

    return {
      locked: state.lockedUntil > currentTime,
      remainingMs: Math.max(0, state.lockedUntil - currentTime),
    };
  }

  function installHiddenLocalPasswordTrigger() {
    if (!document.documentElement.classList.contains('comely-access-blocked')) return;
    if (!isLocalAllowlistBrowser(window.navigator && window.navigator.userAgent)) return;
    if (!document.body) {
      document.addEventListener('DOMContentLoaded', installHiddenLocalPasswordTrigger, { once: true });
      return;
    }
    if (document.documentElement.classList.contains('comely-access-password')) return;
    if (document.querySelector('[data-local-password-trigger]')) return;

    var trigger = document.createElement('button');
    var tapTimes = [];
    var isMobileTrigger = window.innerWidth <= MOBILE_LOCAL_PASSWORD_TRIGGER_MAX_WIDTH;
    var requiredTaps = isMobileTrigger ? MOBILE_LOCAL_PASSWORD_TRIGGER_TAPS : LOCAL_PASSWORD_TRIGGER_TAPS;
    var triggerWindowMs = isMobileTrigger ? MOBILE_LOCAL_PASSWORD_TRIGGER_WINDOW_MS : LOCAL_PASSWORD_TRIGGER_WINDOW_MS;
    trigger.type = 'button';
    trigger.tabIndex = -1;
    trigger.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('data-local-password-trigger', '');
    trigger.style.cssText = isMobileTrigger
      ? 'position:fixed;top:8px;right:8px;width:44px;height:44px;margin:0;padding:0;border:0;background:transparent;opacity:0;z-index:2147483647;cursor:default;touch-action:manipulation;-webkit-tap-highlight-color:transparent;'
      : 'position:fixed;top:0px;right:0px;width:18px;height:18px;margin:0;padding:0;border:0;background:transparent;opacity:0;z-index:2147483647;cursor:default;touch-action:manipulation;-webkit-tap-highlight-color:transparent;';
    trigger.addEventListener('click', function (event) {
      var currentTime = Date.now();
      event.preventDefault();
      event.stopPropagation();
      tapTimes = tapTimes.filter(function (tapTime) {
        return currentTime - tapTime <= triggerWindowMs;
      });
      tapTimes.push(currentTime);

      if (tapTimes.length >= requiredTaps) {
        tapTimes = [];
        renderLocalPasswordPrompt();
      }
    });
    document.body.appendChild(trigger);
  }

  function setPending(isPending) {
    if (!document.documentElement) return;
    document.documentElement.classList.toggle('comely-access-pending', isPending);
  }

  function removePendingStyle() {
    if (window.comelyAccessFailOpenTimer) {
      window.clearTimeout(window.comelyAccessFailOpenTimer);
      window.comelyAccessFailOpenTimer = null;
    }
    var style = document.getElementById('comely-access-pending-style');
    if (style) style.remove();
  }

  function replaceStoreIcons() {
    var iconLinks = document.querySelectorAll(
      'link[rel~="icon"], link[rel="apple-touch-icon"], link[rel="apple-touch-icon-precomposed"], link[rel="mask-icon"]'
    );

    for (var index = 0; index < iconLinks.length; index += 1) {
      iconLinks[index].remove();
    }

    var shopifyIcon = document.createElement('link');
    shopifyIcon.rel = 'icon';
    shopifyIcon.type = 'image/png';
    shopifyIcon.href = 'https://cdn.shopify.com/b/shopify-brochure2-assets/61cc781fe73f11e9d4bd160d27cc627b.png';
    shopifyIcon.setAttribute('data-comely-shopify-icon', '');
    document.head.appendChild(shopifyIcon);

    var shopifyTouchIcon = document.createElement('link');
    shopifyTouchIcon.rel = 'apple-touch-icon';
    shopifyTouchIcon.href = 'https://cdn.shopify.com/b/shopify-brochure2-assets/c97c60ca19c64a8b5378d9f9e971f7bd.png';
    shopifyTouchIcon.setAttribute('data-comely-shopify-icon', '');
    document.head.appendChild(shopifyTouchIcon);
  }

  function createRequestId() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
    } catch (error) {
      // Fall through to a non-identifying local request ID.
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
      var random = Math.floor(Math.random() * 16);
      var value = character === 'x' ? random : (random & 3) | 8;
      return value.toString(16);
    });
  }

  function renderLocalPasswordPrompt() {
    var hadLocalAccess = isLocalAllowlisted();
    setPending(false);
    removePendingStyle();
    document.documentElement.classList.remove('comely-access-blocked');
    document.documentElement.classList.add('comely-access-password');
    document.title = 'Administrator access';
    document.body.innerHTML =
      '<main class="comely-password" role="main">' +
      '<section class="comely-password__card" aria-labelledby="comely-password-title">' +
      '<img class="comely-password__logo" src="https://cdn.shopify.com/shopifycloud/brochure/assets/brand-assets/shopify-logo-primary-logo-456baa801ee66a0a435671082365958316831c9960c480451dd0330bcdae304f.svg" alt="Shopify">' +
      '<h1 id="comely-password-title">Administrator access</h1>' +
      '<p class="comely-password__intro">Enter the access password for this browser.</p>' +
      '<form class="comely-password__form" data-local-password-form>' +
      '<label for="comely-access-password">Access password</label>' +
      '<input id="comely-access-password" name="password" type="password" autocomplete="current-password" autocapitalize="none" spellcheck="false" required>' +
      '<button type="submit">Continue</button>' +
      '<p class="comely-password__status" data-local-password-status role="status" aria-live="polite"></p>' +
      '</form>' +
      (hadLocalAccess ? '<button class="comely-password__revoke" data-local-password-revoke type="button">Remove access from this browser</button>' : '') +
      '</section>' +
      '</main>';

    var style = document.createElement('style');
    style.textContent =
      'html.comely-access-password,html.comely-access-password body{margin:0;min-height:100%;background:#fff;color:#202326;font-family:"Helvetica Neue",Helvetica,Arial,sans-serif}' +
      'html.comely-access-password body{overflow:hidden}' +
      '.comely-password{box-sizing:border-box;display:grid;min-height:100vh;min-height:100svh;place-items:center;padding:28px 20px}' +
      '.comely-password__card{box-sizing:border-box;width:min(100%,420px);text-align:left}' +
      '.comely-password__logo{display:block;width:108px;height:auto;margin:0 auto 46px}' +
      '.comely-password h1{margin:0;text-align:center;font-size:25px;font-weight:500;line-height:1.3;letter-spacing:-.02em}' +
      '.comely-password__intro{margin:14px 0 34px;color:#687078;text-align:center;font-size:15px;font-weight:300;line-height:1.55}' +
      '.comely-password__form label{display:block;margin:0 0 9px;font-size:14px;font-weight:500;line-height:1.4}' +
      '.comely-password__form input{box-sizing:border-box;width:100%;height:50px;padding:0 15px;border:1px solid #c8cdd1;border-radius:6px;background:#fff;color:#202326;font:400 16px/1 "Helvetica Neue",Helvetica,Arial,sans-serif;outline:none;transition:border-color .16s ease,box-shadow .16s ease}' +
      '.comely-password__form input:focus{border-color:#687078;box-shadow:0 0 0 3px rgba(0,0,0,.08)}' +
      '.comely-password__form button{box-sizing:border-box;width:100%;height:48px;margin-top:14px;border:0;border-radius:6px;background:#202326;color:#fff;font:500 15px/1 "Helvetica Neue",Helvetica,Arial,sans-serif;cursor:pointer;transition:opacity .16s ease,transform .16s ease}' +
      '.comely-password__form button:hover{opacity:.88}.comely-password__form button:active{transform:scale(.99)}.comely-password__form button:focus-visible{outline:3px solid rgba(32,35,38,.24);outline-offset:3px}' +
      '.comely-password__form button:disabled{cursor:not-allowed;opacity:.5;transform:none}' +
      '.comely-password__status{min-height:22px;margin:13px 0 0;color:#b42318;text-align:center;font-size:13px;line-height:1.5}' +
      '.comely-password__revoke{display:block;margin:8px auto 0;padding:5px;border:0;background:transparent;color:#687078;font:400 13px/1.4 "Helvetica Neue",Helvetica,Arial,sans-serif;text-decoration:underline;text-underline-offset:3px;cursor:pointer}' +
      '.comely-password__revoke:focus-visible{outline:2px solid #687078;outline-offset:3px}' +
      '@media(max-width:480px){.comely-password{padding:24px}.comely-password__card{width:min(100%,360px)}.comely-password__logo{width:100px;margin-bottom:38px}.comely-password h1{font-size:23px}.comely-password__intro{margin-bottom:29px}}' +
      '@media(prefers-reduced-motion:reduce){.comely-password__form input,.comely-password__form button{transition:none}}';
    document.head.appendChild(style);

    var form = document.querySelector('[data-local-password-form]');
    var input = document.getElementById('comely-access-password');
    var button = form.querySelector('button[type="submit"]');
    var status = document.querySelector('[data-local-password-status]');
    var revoke = document.querySelector('[data-local-password-revoke]');

    if (revoke) {
      revoke.addEventListener('click', function () {
        removeLocalAllowlist();
        clearLocalPasswordAttempts();
        window.location.reload();
      });
    }

    function showLockState(remainingMs) {
      var seconds = Math.max(1, Math.ceil(remainingMs / 1000));
      button.disabled = true;
      status.textContent = 'Too many attempts. Try again in ' + seconds + ' seconds.';
      window.setTimeout(function () {
        button.disabled = false;
        status.textContent = '';
        input.focus();
      }, remainingMs + 50);
    }

    if (!/^[a-f0-9]{64}$/i.test(LOCAL_PASSWORD_HASH)) {
      button.disabled = true;
      status.textContent = 'Access password is not configured.';
    } else {
      var initialLockRemaining = getLocalPasswordLockRemaining();
      if (initialLockRemaining > 0) showLockState(initialLockRemaining);
      else input.focus();
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var lockRemaining = getLocalPasswordLockRemaining();
      if (lockRemaining > 0) {
        showLockState(lockRemaining);
        return;
      }

      button.disabled = true;
      status.textContent = '';
      verifyLocalAllowlistPassword(input.value).then(function (matches) {
        if (matches && grantLocalAllowlist()) {
          clearLocalPasswordAttempts();
          status.style.color = '#16803a';
          status.textContent = 'Access granted. Reloading…';
          window.location.reload();
          return;
        }

        var failure = registerLocalPasswordFailure();
        input.value = '';
        if (failure.locked) {
          showLockState(failure.remainingMs);
          return;
        }

        button.disabled = false;
        status.textContent = 'Incorrect password. Please try again.';
        input.focus();
      });
    });
  }

  function renderBlockedPage(decision) {
    var requestId = createRequestId();

    setPending(false);
    removePendingStyle();
    document.documentElement.classList.add('comely-access-blocked');
    document.documentElement.setAttribute('data-comely-access-decision', decision.reasons.join(''));

    replaceStoreIcons();
    document.title = 'Store unavailable';
    document.body.innerHTML =
      '<main class="comely-unavailable" role="main">' +
      '<section class="comely-unavailable__card" aria-labelledby="comely-unavailable-title">' +
      '<a class="comely-unavailable__shopify-logo" data-shopify-logo href="https://www.shopify.com/" aria-label="Shopify">' +
      '<img src="https://cdn.shopify.com/shopifycloud/brochure/assets/brand-assets/shopify-logo-primary-logo-456baa801ee66a0a435671082365958316831c9960c480451dd0330bcdae304f.svg" alt="Shopify">' +
      '</a>' +
      '<div class="comely-unavailable__status">' +
      '<svg class="comely-unavailable__warning" data-unavailable-warning aria-hidden="true" viewBox="0 0 40 40" fill="none">' +
      '<path d="M20 2.75 38 36.25H2L20 2.75Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
      '<path d="M20 13v11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
      '<circle cx="20" cy="29.5" r="1.15" fill="currentColor"/>' +
      '</svg>' +
      '<h1 id="comely-unavailable-title">Something went wrong.</h1>' +
      '</div>' +
      '<div class="comely-unavailable__details" data-unavailable-details>' +
      '<h2>What happened?</h2>' +
      '<span class="comely-unavailable__rule" aria-hidden="true"></span>' +
      '<p>This store is unavailable.</p>' +
      '</div>' +
      '<div class="comely-unavailable__action" data-unavailable-action>' +
      '<h2>What can I do?</h2>' +
      '<span class="comely-unavailable__rule" aria-hidden="true"></span>' +
      '<p>Please try again later.</p>' +
      '</div>' +
      '<p class="comely-unavailable__request-id" data-unavailable-request-id>Request ID: ' + requestId + '</p>' +
      '</section>' +
      '</main>';

    var style = document.createElement('style');
    style.textContent =
      'html.comely-access-blocked,html.comely-access-blocked body{margin:0;min-height:100%;background:#fff;color:#30363b;font-family:"Helvetica Neue",Helvetica,Arial,sans-serif}' +
      'html.comely-access-blocked body{overflow:hidden}' +
      '.comely-unavailable{box-sizing:border-box;display:grid;min-height:100vh;min-height:100svh;place-items:center;padding:30px 20px}' +
      '.comely-unavailable__card{box-sizing:border-box;display:flex;flex-direction:column;width:min(100%,580px);min-height:min(640px,calc(100svh - 60px));margin:0 auto;text-align:center}' +
      '.comely-unavailable__shopify-logo{display:block;width:108px;margin:0 auto 54px}' +
      '.comely-unavailable__shopify-logo img{display:block;width:100%;height:auto}' +
      '.comely-unavailable,.comely-unavailable h1,.comely-unavailable h2,.comely-unavailable p{font-family:"Helvetica Neue",Helvetica,Arial,sans-serif}' +
      '.comely-unavailable__status{display:grid;width:min(100%,350px);margin:0 auto;grid-template-columns:40px minmax(0,1fr) 40px;align-items:center}' +
      '.comely-unavailable__warning{display:block;grid-column:1;width:40px;height:40px;color:#e6a700;justify-self:start}' +
      '.comely-unavailable h1{grid-column:2;min-width:0;margin:0;color:#61676b;font-size:20px;font-weight:300;line-height:1.4;letter-spacing:-.015em;text-align:center}' +
      '.comely-unavailable__details{margin:92px 0 0;text-align:center}' +
      '.comely-unavailable__action{margin:72px 0 0;text-align:center}' +
      '.comely-unavailable h2{margin:0;font-size:16px;font-weight:500;line-height:1.4}' +
      '.comely-unavailable__rule{display:block;width:76px;height:2px;margin:24px auto 26px;background:#e3e5e7}' +
      '.comely-unavailable p{margin:0;color:#74797d;font-size:14px;font-weight:300;line-height:1.6}' +
      '.comely-unavailable__request-id{margin:auto 0 0;color:#c2c6c9;font-size:12px;line-height:1.4;text-align:center}' +
      '@media(min-width:481px){.comely-unavailable{align-items:start;padding-top:255px}.comely-unavailable__card{display:block;min-height:0}.comely-unavailable__shopify-logo{margin-bottom:30px}.comely-unavailable__details{margin-top:80px}.comely-unavailable__action{margin-top:84px}.comely-unavailable h2{color:#30363b;font-weight:400}.comely-unavailable__rule{margin-top:20px;margin-bottom:22px}.comely-unavailable p.comely-unavailable__request-id{position:static;margin:184px 0 58px;color:#c2c6c9;font-size:12px;line-height:1.4}}' +
      '@media(max-width:480px){.comely-unavailable{padding:28px 20px}.comely-unavailable__card{display:block;min-height:0;text-align:center}.comely-unavailable__shopify-logo{width:100px;margin:0 auto 36px}.comely-unavailable__status{width:min(100%,350px);margin:0 auto;grid-template-columns:36px minmax(0,1fr) 36px;column-gap:0}.comely-unavailable__warning{width:36px;height:36px}.comely-unavailable h1{text-align:center;font-size:18px}.comely-unavailable__details{margin:56px 0 0;text-align:center}.comely-unavailable__action{margin:52px 0 0;text-align:center}.comely-unavailable__rule{margin:19px auto 21px}.comely-unavailable__request-id{margin:44px 0 0;text-align:center}}' +
      '@media(max-width:340px){.comely-unavailable h1{font-size:17px}}';
    document.head.appendChild(style);

    window.ComelyAccessGuard.lastDecision = decision;
    installHiddenLocalPasswordTrigger();
  }

  function currentSignals(countryCode) {
    return {
      countryCode: countryCode,
      languages: getLanguages(),
      timezone: getTimezone(),
      userAgent: window.navigator.userAgent || '',
    };
  }

  function requestDetectedCountry() {
    if (typeof window.fetch !== 'function') return Promise.resolve('');

    var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
    var timer = window.setTimeout(function () {
      if (controller) controller.abort();
    }, GEO_TIMEOUT_MS);
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

    return window
      .fetch(root + 'browsing_context_suggestions.json', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: controller ? controller.signal : undefined,
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Country lookup failed');
        return response.json();
      })
      .then(function (data) {
        var countryCode = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        return normalizeCountryCode(countryCode);
      })
      .catch(function () {
        return '';
      })
      .finally(function () {
        window.clearTimeout(timer);
      });
  }

  function start() {
    if (!ACCESS_GUARD_ENABLED || !window.navigator || !document.documentElement) return;

    setPending(true);
    if (isLocalAllowlisted()) {
      window.ComelyAccessGuard.lastDecision = {
        blocked: false,
        reasons: [],
        browser: null,
        bypass: 'local-allowlist',
      };
      setPending(false);
      removePendingStyle();
      return;
    }

    var cachedCountry = readCountryCache();
    var initialDecision = evaluateAccess(currentSignals(cachedCountry));
    window.ComelyAccessGuard.lastDecision = initialDecision;

    if (initialDecision.blocked) {
      if (document.readyState !== 'loading') renderBlockedPage(initialDecision);
      else document.addEventListener('DOMContentLoaded', function () { renderBlockedPage(initialDecision); }, { once: true });
      return;
    }

    requestDetectedCountry().then(function (countryCode) {
      if (countryCode) writeCountryCache(countryCode);
      var finalDecision = evaluateAccess(currentSignals(countryCode));
      window.ComelyAccessGuard.lastDecision = finalDecision;

      if (finalDecision.blocked) {
        if (document.readyState !== 'loading') renderBlockedPage(finalDecision);
        else document.addEventListener('DOMContentLoaded', function () { renderBlockedPage(finalDecision); }, { once: true });
        return;
      }

      setPending(false);
      removePendingStyle();
    });
  }

  window.ComelyAccessGuard = {
    evaluateAccess: evaluateAccess,
    identifyBlockedBrowser: identifyBlockedBrowser,
    matchesBlockedCountry: matchesBlockedCountry,
    matchesLanguageAndTimezone: matchesLanguageAndTimezone,
    isLocalAllowlistBrowser: isLocalAllowlistBrowser,
    isLocalAllowlisted: isLocalAllowlisted,
    grantLocalAllowlist: grantLocalAllowlist,
    verifyLocalAllowlistPassword: verifyLocalAllowlistPassword,
    registerLocalPasswordFailure: registerLocalPasswordFailure,
    getLocalPasswordLockRemaining: getLocalPasswordLockRemaining,
    start: start,
    lastDecision: null,
  };

  if (document.currentScript) start();
})(window, document);
